import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';


createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
   <BrowserRouter>
  
       <App />
  </BrowserRouter>
  </React.StrictMode>
);